<script setup lang="ts">
import { useCommonStore } from './stores/modules/common'
import Home from './views/home/Home.vue'
import Start from './views/start/Start.vue'
import Item from './views/item/Item.vue'
import Fight from './views/fight/Fight.vue'
import User from './views/user/User.vue'
import Mail from './views/mail/Mail.vue'
import Smithy from './views/smithy/Smithy.vue'
import Warehouse from './views/warehouse/Warehouse.vue'
import Mall from './views/mall/Mall.vue'
import Dungeon from './views/dungeon/Dungeon.vue'
import Institute from './views/institute/Institute.vue'
import BlackMarket from './views/black-market/BlackMarket.vue'
import Commerce from './views/commerce/Commerce.vue'
import EquipHandbook from './views/equip-handbook/EquipHandbook.vue'
import Treasury from './views/treasury/Treasury.vue'
import PetRanch from './views/pet-ranch/PetRanch.vue'
import Pub from './views/pub/Pub.vue'
import { dayjs, ElMessageBox } from 'element-plus'
import Awaken from './views/awaken/Awaken.vue'
import { useUserStore } from './stores/modules/user'
import Rank from './views/rank/Rank.vue'
import OccultScience from './views/occult-science/OccultScience.vue'
import DarkGoldWorkshop from './views/dark-gold-workshop/DarkGoldWorkshop.vue'
import Relic from './views/relic/Relic.vue'
import OneYear from './views/one-year/OneYear.vue'
import { onBeforeMount } from 'vue'
import SecondAwaken from './views/second-awaken/SecondAwaken.vue'
import SupremeWorkshop from './views/supreme-workshop/SupremeWorkshop.vue'
import MagicWorkshop from './views/maigc-workshop/MagicWorkshop.vue'

const envMode = import.meta.env.VITE_ENV_MODE

const commonStore = useCommonStore()
const userStore = useUserStore()

setInterval(() => {
  const time = dayjs().format('HH:mm:ss')
  if (time !== '00:00:05') return
  ElMessageBox.alert('数据刷新，请重新登入游戏').then(() => {
    location.reload()
  })
}, 1000)

onBeforeMount(() => {
  const uiZoomLocalKey = `war-soul-${envMode === 'test' ? 'test-' : ''}ui-zoom`
  document.documentElement.style.setProperty('zoom', localStorage.getItem(uiZoomLocalKey) || '1')
  const uiModeLocalKey = `war-soul-${envMode === 'test' ? 'test-' : ''}ui-mode`
  const uiMode = localStorage.getItem(uiModeLocalKey) || 'dark'
  document.documentElement.setAttribute('class', uiMode)
  commonStore.isDarkMode = uiMode === 'dark'
})
</script>

<template>
  <div class="main">
    <Start v-show="commonStore.path === 'Start'" />
    <Home v-show="commonStore.path === 'Home'" />
    <Item v-show="commonStore.path === 'Item'" />
    <Fight v-show="commonStore.path === 'Fight'" />
    <User v-show="commonStore.path === 'User'" />
    <Mail v-show="commonStore.path === 'Mail'" />
    <Smithy v-if="commonStore.path === 'Smithy'" />
    <Warehouse v-if="commonStore.path === 'Warehouse'" />
    <Mall v-show="commonStore.path === 'Mall'" />
    <Dungeon v-show="commonStore.path === 'Dungeon'" />
    <Institute v-if="commonStore.path === 'Institute'" />
    <BlackMarket v-show="commonStore.path === 'BlackMarket'" />
    <Commerce v-show="commonStore.path === 'Commerce'" />
    <EquipHandbook v-show="commonStore.path === 'EquipHandbook'" />
    <Treasury v-show="commonStore.path === 'Treasury'" />
    <PetRanch v-show="commonStore.path === 'PetRanch'" />
    <Pub v-show="commonStore.path === 'Pub'" />
    <Awaken v-show="commonStore.path === 'Awaken'" />
    <SecondAwaken v-show="commonStore.path === 'SecondAwaken'" />
    <Rank v-show="commonStore.path === 'Rank'" />
    <OccultScience v-show="commonStore.path === 'OccultScience'" v-if="userStore.soulType" />
    <DarkGoldWorkshop v-if="commonStore.path === 'DarkGoldWorkshop'" />
    <Relic v-show="commonStore.path === 'Relic'" v-if="userStore.advanceLevel === 4" />
    <SupremeWorkshop v-if="commonStore.path === 'SupremeWorkshop'" />
    <MagicWorkshop v-show="commonStore.path === 'MagicWorkshop'" v-if="userStore.peakLevel === 8" />
    <OneYear v-show="commonStore.path === 'OneYear'" />
    <!-- <PvpCard v-if="commonStore.path === 'PvpCard'" /> -->
  </div>
</template>

<style lang="scss">
@import './assets/styles/index.scss';
</style>
